var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container",style:({
      opacity: _vm.screensaverOpacity,
      transform: `scale(${_vm.screensaverOpacity * 0.1 + 0.9})`,
      backgroundImage:
        'url(https://muenchen.frechdax-abdl.de/flyer/flyer_2025-10-11_001-thumb.jpg)',
    })}),_c('div',{staticClass:"flyer-bg",style:({
      opacity: _vm.screensaverOpacity,
      backgroundImage:
        'url(https://muenchen.frechdax-abdl.de/flyer/flyer_2025-10-11_001-blur.jpg)',
    })})])
}
var staticRenderFns = []

export { render, staticRenderFns }